import {
	primaryColor,
} from 'assets/jss/material-dashboard-pro-react.js';

const styles = {
	previewContainer: {
		margin: '0px -20px',
		backgroundColor: '#F5F5F5',
		width: 'calc(100% + 40px)',
	},
	previewDeviceContainer: {
		width: '100%',
		justifyContent: 'center',
		margin: '0px',
	},
	previewButtons: {
		color: '#F5F5F5',
	},
	previewPillsHeader: {
		minHeight: '20px',
	},
	previewPillsButtons: {
		height: '20px',
		minHeight: '25px !important',
		lineHeight: '6px',
		width: '72px',
		minWidth: '70px',
	},
	previewPillsContent: {
		marginBottom: '20px',
	},
	previewImageIos: {
		position: 'relative',
		flexBasis: 'unset',
		marginLeft: '20px',
		marginRight: '20px',
		marginTop: '10px',
		marginBottom: '20px',
		minWidth: '330px',
		width: '330px',
		height: '600px',
	},
	previewImageAndroid: {
		position: 'relative',
		flexBasis: 'unset',
		marginLeft: '20px',
		marginRight: '20px',
		marginTop: '10px',
		marginBottom: '20px',
		minWidth: '330px',
		width: '330px',
		height: '634px',
	},
	firstLine: {
		fontWeight: '600',
	},
	iosPushNotification: {
		position: 'absolute',
		top: '75px',
		left: '49px',
		fontSize: '11px',
		fontWeight: '500',
		lineHeight: 'initial',
		overflow: 'hidden',
		width: '235px',
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis',
	},
	iosCallNumber: {
		color: '#FFFFFF',
		position: 'absolute',
		top: '67px',
		left: '49px',
		fontSize: '23px',
		fontWeight: '500',
		lineHeight: 'initial',
		width: '235px',
		textAlign: 'center',
		overflow: 'hidden',
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis',
	},
	iosCallMessage: {
		color: '#ffffff92',
		position: 'absolute',
		top: '100px',
		left: '40px',
		fontSize: '14px',
		fontWeight: '400',
		lineHeight: 'initial',
		width: '252px',
		textAlign: 'center',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	androidPushNotificationTitle: {
		position: 'absolute',
		top: '186px',
		left: '42px',
		fontSize: '11px',
		fontWeight: '500',
		lineHeight: 'initial',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	androidPushNotification: {
		position: 'absolute',
		top: '200px',
		left: '42px',
		fontSize: '11px',
		fontWeight: '500',
		lineHeight: 'initial',
		width: '245px',
	},
	androidPushNotificationCallPurpose: {
		fontSize: '11px',
		fontWeight: '500',
		lineHeight: 'initial',
		width: '245px',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	androidVerifiedPreviewText: {
		color: '#000000',
		position: 'absolute',
		top: '447px',
		left: '34px',
		width: '260px',
		fontSize: '14px',
		fontWeight: '500',
		textAlign: 'center',
	},
	androidVerifiedMessage: {
		color: '#000000',
		fontSize: '14px',
		lineHeight: 'initial',
		width: '260px',
		textAlign: 'center',
		fontWeight: '400',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	androidEnterpriseName: {
		color: '#000000',
		fontWeight: '400',
	},
	androidUnVerifiedMessage: {
		color: primaryColor[0],
		position: 'absolute',
		top: '469px',
		left: '64px',
		fontSize: '14px',
		fontWeight: 'bold',
		lineHeight: 'initial',
		width: '200px',
		textAlign: 'center',
	},
	previewIosImageContainer: {
		position: 'absolute',
		top: '13px',
		left: '32px',
		width: '270px',
		height: '573px',
		borderRadius: '28px',
		overflow: 'hidden',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	previewAndroidImageContainer: {
		position: 'absolute',
		top: '35px',
		left: '24px',
		width: '280px',
		height: '583px',
		overflow: 'hidden',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	notificationPreviewImageIos: {
		maxHeight: '575px',
	},
	notificationPreviewImageAndroid: {
		maxHeight: '583px',
	},
	absoluteImage: {
		position: 'absolute',
		top: 0,
	},
	saturation: {
		position: 'absolute',
		top: '13px',
		left: '32px',
		width: '270px',
		height: '573px',
		borderRadius: '28px',
		overflow: 'hidden',
		backgroundColor: 'rgb(0 0 0/29.8%)',
	}
};

export default styles;